import * as PourOver from 'pourover';

import { FilterBase } from './FilterBase';

export class IncumbentProductsFilter extends FilterBase {
  skipIntersection = true;

  makeIndex(): any {
    return new PourOver.makeExactFilter('sortIndex', [0]);
  }

  getMatchSet(collection: any, filterSettings): any {
    return collection.filters.sortIndex.getFn(0);
  }

  getCounts(filterCombinations): any {
    let intersection = filterCombinations.intersection;
    let incumbentsFilter = filterCombinations.incumbentsFilter;

    return {
      incumbents: intersection.and(incumbentsFilter).cids.length
    };
  }
}
